<script setup>
const props = defineProps({
    titulo: {
        type: String,
        required: true
    },
    descricao: {
        type: String,
        required: false,
        default: ''
    },
    carregamento: {
        type: Boolean,
        required: false,
        default: false
    },
    titulosize: {
        type: String,
        required: false,
        default: 'text-3xl'
    },
    separacao: {
        type: Boolean,
        required: false,
        default: false
    },
});

</script>

<template>
    <div class="relative" style="contain: inline-size;">
        <div class="mb-5 flex flex-column justify-content-between gap-4 align-items-start">
            <CabecalhoListas :titulo="props.titulo" :descricao="props.descricao" :tituloSize="props.titulosize">
                <template v-if="$slots['titulo']" #titulo>
                    <slot name="titulo" />
                </template>
            </CabecalhoListas>

            <Toolbar class="w-full" :pt="{ center: 'hidden' }">
                <template #start>
                    <slot name="cabecalho-inicio">
                    </slot>
                </template>

                <template #end>
                    <slot name="cabecalho-fim">
                    </slot>
                </template>
            </Toolbar>

            <hr v-if="props.separacao" class="w-full border-solid border-top-1 border-bottom-none surface-border my-2">
        </div>

        <Carregador :carregando="props.carregamento" class="card flex justify-content-center pt-6">
            <div class="relative" style="contain: inline-size;">
                <slot name="corpo-tabela">

                </slot>
            </div>
        </Carregador>
    </div>
</template>